export const READ_NOTIFICATION = 'READ_NOTIFICATION';
export const INSTANT_NOTIFICATION = 'INSTANT_NOTIFICATION';
export const PRIVATE_TOKEN_NOTIFICATION = 'PRIVATE_TOKEN_NOTIFICATION';
export const GET_MEMBER_NOTIFICATIONS_LIST = 'GET_MEMBER_NOTIFICATIONS_LIST';

export const OPEN_NOTIFICATIONS_WINDOW = 'OPEN_NOTIFICATIONS_WINDOW';
export const CLOSE_NOTIFICATIONS_WINDOW = 'CLOSE_NOTIFICATIONS_WINDOW';
export const COUNTER_NOTIFICATION = 'COUNTER_NOTIFICATION';


// WEBPACK FOOTER //
// ./src/constants/notifications.js